import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

function ColumnDate({ width, date, style }) {
  return (
    <div className={`type-placeholder`} style={{ width, ...style}}>{ dayjs(date).format(`MMM DD, YYYY`) }</div>
  )
}

ColumnDate.propTypes = {
  width: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  style: PropTypes.object,
}

export default ColumnDate;
